import { render, staticRenderFns } from "./PefTable.vue?vue&type=template&id=bd2da190&scoped=true&"
import script from "./PefTable.vue?vue&type=script&lang=js&"
export * from "./PefTable.vue?vue&type=script&lang=js&"
import style0 from "./PefTable.vue?vue&type=style&index=0&id=bd2da190&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2da190",
  null
  
)

export default component.exports